import { h } from "preact";

import IconProps from "../../Icons/IconProps";

const DEFAULT_COLOR = "var(--label-primary)";

export default function IconTrash({
    class: cssClass,
    color
}: IconProps) {
    const iconColor = color ?? `var(--icon-color, ${DEFAULT_COLOR})`;

    return (
        <svg class={cssClass} width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path stroke={iconColor} d="M8 8.5h8v8a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1v-8z"/>
            <rect fill={iconColor} width="6" height="1" rx=".5" transform="matrix(0 -1 -1 0 11 16)"/>
            <rect fill={iconColor} width="6" height="1" rx=".5" transform="matrix(0 -1 -1 0 14 16)"/>
            <rect fill={iconColor} x="6" y="8" width="12" height="1" rx=".5"/>
            <path stroke={iconColor} d="M12.5 6.5a1 1 0 0 1 1 1v1h-3v-1a1 1 0 0 1 1-1h1z"/>
        </svg>
    );
}
